import type React from 'react';

import BaseLoader from '@vlabs/shared/legacy-components/loader/Loader';

import st from './Loader.module.sass';

function Loader(): React.JSX.Element {
  return (
    <div className={st.Container}>
      <BaseLoader />
    </div>
  );
}

export { Loader };
